module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"footerLabels":{"mainFooterLabel":"{0} Bensussen Deutsch & Associates, LLC."}}}')
  delete Component.options._Ctor
}
